import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import styled from 'styled-components'
import { shouldTranslateTo } from '../../utils/utils'
import { Subtitle, ActionButtons } from '../Utils/CustomClasses'
import { scrollIntoView } from '../Hooks/ScrollView'

const ContainerBox = styled.div`
  padding: 30px 36px 55px 36px;
  background-color: #ffffff;

  @media (max-width: 767px) {
    padding: 25px 25px 25px 25px;
  }
`

const PaymentButton = styled(ActionButtons)`
  @media screen and (max-width: 799px) {
    width: -webkit-fill-available;
  }
`

const PriceChoiceBox = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 5px 9px -2px #b5b5b5;
  border: 1px solid #eee;
  padding: 30px;
  margin: 40px 0 0;
  width: 100%;
`

const FlexRowPrice = styled.div`
  display: flex;
  flex-direction: row;
  gap: 50px;
  align-items: top;
  justify-content: left;
  margin-top: 10px;

  @media (max-width: 799px) {
    flex-direction: column;
    margin-top: 20px;

    & > div {
      width: -webkit-fill-available;
    }
  }
`

const InfoBox = styled.div`
  flex-basis: 100%%;

  @media (max-width: 799px) {
    text-align: center;
  }
`

const PriceChoiceTitle = styled(Subtitle)`
  @media (max-width: 799px) {
    font-size: 22px !important;
  }
`

const PriceChoiceSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-weight: 200;
  margin: 24px 20px 30px 0;

  span {
    text-transform: capitalize;
  }

  @media (max-width: 799px) {
    font-size: 18px !important;
  }
`

const FlexRowButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 60px;
  font-size: 16px;
`

const TrackIFrame = styled.div`
  visibility: hidden;
  height: 0;
`

const FeeCompletedApp = ({ actionRef, data, onUpdate }) => {
  const [pageText, setPageText] = useState([])

  useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('profile-pay', language)

    setTimeout(function () {
      scrollIntoView(actionRef)
    }, 1000)
  }, [])

  const handleButtonClick = (e) => {
    e.preventDefault()
    onUpdate()
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[10]}</span>
        </div>
      </div>
    )
  }
  return (
    <div className="container">
      <div className="row justify-content-center">
        <ContainerBox actionRef={actionRef}>
          <PriceChoiceBox>
            <FlexRowPrice>
              <InfoBox>
                {' '}
                <PriceChoiceTitle size="22px" bold margin="6px 0 10px 1%">
                  Payment successful
                </PriceChoiceTitle>
                <PriceChoiceSubtitle
                  size="16px"
                  margin="0 0 10px 1%"
                  dangerouslySetInnerHTML={{
                    __html: `Thank you for your payment. Please click the button below to continue.`,
                  }}
                />
                <img
                  src={
                    'https://www.shareasale.com/sale.cfm?tracking=' +
                    data.auth.user.id +
                    '&amount=' +
                    (
                      Math.round(data.auth.user.membershipFee * 100) / 100
                    ).toFixed(2) +
                    '' +
                    '&currency=' +
                    data.auth.user.currencyValue +
                    '&merchantID=160393&transtype=sale&v=gtm_1.0'
                  }
                  width="1"
                  height="1"
                />
                <TrackIFrame>
                  <iframe
                    src={
                      'https://freebirdclub.com/fb-track?amt=' +
                      (
                        Math.round(data.auth.user.membershipFee * 100) / 100
                      ).toFixed(2) +
                      '&cur=' +
                      data.auth.user.currencyValue +
                      ''
                    }
                    className="trackIframe"
                  ></iframe>
                </TrackIFrame>
                <TrackIFrame>
                  <iframe
                    src={
                      'https://freebirdclub.com/google-track?amt=' +
                      (
                        Math.round(data.auth.user.membershipFee * 100) / 100
                      ).toFixed(2) +
                      '&cur=' +
                      data.auth.user.currencyValue +
                      ''
                    }
                    className="trackIframe"
                  ></iframe>
                </TrackIFrame>
                <FlexRowButtons>
                  <PaymentButton
                    padding="10px 30px"
                    onClick={(e) => {
                      handleButtonClick(e)
                    }}
                  >
                    Continue
                  </PaymentButton>
                </FlexRowButtons>
              </InfoBox>
            </FlexRowPrice>
          </PriceChoiceBox>
        </ContainerBox>
      </div>
    </div>
  )
}

export default withRouter(withAuth(FeeCompletedApp))
